import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getpath } from "../actions/get-path";
import { getAction } from "../actions/get-action";
import { Table } from "semantic-ui-react";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wod: null,
      unassigned: null
    };
  }
  componentDidMount() {
    if (this.props.params.wonum && this.props.wods) {
      this.wodpop();
    }
    this.props.getpath("Phone Book", "phone");
    this.props.get("inventory");
  }
  gentable() {
    if (this.props.employees) {
      return this.props.employees.map(emp => {
        return (
          <Table.Row
            onClick={() => {
              this.setState({ activeemp: emp });
            }}
          >
            <Table.Cell>{emp.firstname + " " + emp.lastname}</Table.Cell>
            <Table.Cell>{emp.cellphonenumber}</Table.Cell>
            <Table.Cell>{emp.workphone}</Table.Cell>
            <Table.Cell>{emp.homephone}</Table.Cell>

            <Table.Cell>{emp.workemail}</Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  //  <Table.Body>{this.gentable()}</Table.Body>
  render() {
    if (this.props.employees) {
      return (
        <div className="JobTracker">
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Cell Phone</Table.HeaderCell>
                <Table.HeaderCell>Work Phone</Table.HeaderCell>
                <Table.HeaderCell>Home Phone</Table.HeaderCell>
                <Table.HeaderCell>Email</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.gentable()}</Table.Body>
          </Table>
        </div>
      );
    } else {
      return <div />;
    }
  }
}
function mapStateToProps(state) {
  return {
    employees: state.employees.employees,
    wods: state.workorders.derivitives,
    jobs: state.jobs.assignedjobs,
    myinfo: state.myinfo.employeeinfo
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getpath: getpath,
      get: getAction
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/phone.js